<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header @custom-event="getToken"></Header>
		<div class="page_content">
			
			<!--全部评论-开始-->
			<el-dialog
			  title="用戶點評"
			  :visible.sync="commentsDialog"
			  :destroy-on-close="true"
			  width="50%">
			  <div class="starlist_group">
			  	<div class="item" v-for="(item, index) in commentsList" :key="index">
			  		<div class="ud_star">
			  			<div class="ud">
			  				<h3>{{item.NickName}}</h3>
			  				<p class="date">發佈於 {{item.PostDate}}</p>
			  			</div>
			  			<div class="star_group">
			  				<div :class="getListStarClass(item.Star)"></div>
			  			</div>
			  		</div>
			  		<div class="u_post" v-html="item.Content">
			  		</div>
			  		<div class="op_reply" v-if="item.Reply !=''">
			  			<h3>管理員回覆：</h3>
			  			<div v-html="item.Reply"></div>
			  		</div>
			  	</div>
			  </div>
			</el-dialog>
			<!--全部评论-结束-->
			
			<!--全部图片-开始-->
			<el-dialog
			  title="圖庫"
			  :visible.sync="gallerysDialog"
			  :fullscreen="true"
			  custom-class="gallerysDialog"
			  >
			  <div class="gallerys_box" v-if="Gallerys.length>0">
				  <div class="left_items">
					  <div class="thumb">
					  	<ul>
					  		<li class="selected" v-if="index == galleryIndex" v-for="(item, index) in Gallerys" :key="index" @click="changeGallery(index)">
					  			<img :src="item.Picture" />
					  		</li>
					  		<li v-else @click="changeGallery(index)">
					  			<img :src="item.Picture" />
					  		</li>
					  	</ul>
					  </div>
				  </div>
				  <div class="right_preview">
					  <transition name="fade"><img v-if="showImage" :src="Gallerys[galleryIndex].Picture" /></transition>
				  </div>
			  </div>
			</el-dialog>
			<!--全部图片-结束-->
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span><a href="/tw/recreation">景點玩樂</a><span class="space">/</span>{{recreationDetail.Title}}
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--图片区-开始-->
			<div class="pub_div dp_picture_box">
				<div class="focus_box">
					<div class="view_more" @click.stop="viewAllPictures()">更多圖片</div>
					<el-image
					style="width: 100%; height: 372px; border-radius: 8px;"
					:src="focusPicture"
					fit="cover"></el-image>
				</div>
				<div class="other_box">
					<div class="item" v-for="(item, index) in otherPictureList" :key="index">
						<el-image
						style="width: 100%; height: 180px; border-radius: 8px;"
						:src="item"
						fit="cover"></el-image>
					</div>
				</div>
			</div>
			<!--图片区-结束-->
			
			<!--Tab控制栏-开始-->
			<div class="sticky_box">
			<div class="pub_div tab_ctroller_box">
				
				<div class="tab_box">
					<el-tabs v-model="activeTab" stretch @tab-click="handleTabClick">
						<el-tab-pane v-for="item in tabList" :key="item.id" :label="item.label" :name="item.id" />
					</el-tabs>					
					
				</div>
				
				<div class="favorite_box">
					<span v-if="CollectionState == 0" @click="collectionHandle(1)">收藏</span>
					<span class="selected" v-if="CollectionState == 1" @click="collectionHandle(0)">取消收藏</span>
				</div>
				
			</div>
			</div>
			<!--Tab控制栏-结束-->
			
			<!--基础信息-开始-->
			<div class="pub_div basic_information_box" id="tab1">
				
				<!--左侧-开始-->
				<div class="left_box" style="width: 100%;">
					<h1>{{recreationDetail.Title}}</h1>
					<div class="ext_box">
						<span class="location">{{recreationDetail.Location}}</span>
						<span>遊玩時間：{{recreationDetail.PlayHours}}</span>
					</div>
					<!--属性-开始-->
					<div class="attribute">						
						<div class="tag business_time" v-if="recreationDetail.BusinessTime !== '' && recreationDetail.BusinessTime !== null">{{recreationDetail.BusinessTime}}</div>
						<div class="tag valid">有效期 {{recreationDetail.ValidityDate}}</div>
						<div class="tag sale">折扣優惠</div>
					</div>
					<!--属性-结束-->
					<!--摘要-开始-->
					<div class="description" v-if="recreationDetail.SubTitle != ''" v-html="recreationDetail.SubTitle"></div>
					<!--摘要-结束-->
					
					<!--价格与预订按钮-开始-->
					<div class="order_box" v-if="showPrice !='0.00'">
						<div class="price_box">
							<div class="price_items">
								<div class="show_price">${{recreationDetail.ShowPrice}}</div>
								<div class="discount_price">${{recreationDetail.DiscountPrice}}<em>起</em></div>
							</div>
							<div class="tips">
								該價格包含接送服務
							</div>
						</div>
						<div class="button_box">
							<div class="btn" @click="booking()">立即預訂</div>
						</div>
					</div>
					<!--价格与预订按钮-结束-->
					
					<!--酒店、套餐栏目特有内容-->
				</div>
				<!--左侧-结束-->
				
				<!--评论区-开始-->
				<!-- <div class="right_box">
					<Pinglun :Comments="recreationDetail.Comments" @custom-event="viewAllComments"></Pinglun>
				</div> -->
				<!--评论区-结束-->
				
			</div>			
			<!--基础信息-结束-->
			
			<!--详细内容等富文本内容-开始-->
			<div class="html_content_box">
				<div class="html_section" id="tab2">
					<div class="title">詳細介紹</div>
					<div class="hs_content" v-html="recreationContent"></div>
				</div>
				<div class="html_section" id="tab3">
					<div class="title">訂購須知</div>
					<div class="hs_content" v-html="recreationDetail.Notice"></div>
				</div>
				<div class="html_section" id="tab4">
					<div class="title">費用明細</div>
					<div class="hs_content" v-html="recreationDetail.PriceTip"></div>
				</div>
				<div class="html_section" id="tab5">
					<div class="title">接送地點</div>
					<div class="hs_content" v-html="recreationDetail.CollectionPlace"></div>
				</div>
			</div>
			<!--详细内容等富文本内容-结束-->
			
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
	const TAB_OFFSET_TOP = 80;	//块内容距顶部距离
	
	import {
		getRecreationDetail,
		checkToken,
		collection,
		getAllComments,
		getRecreationPrice,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	import Pinglun from '@/components/tw_pinglun.vue'
	export default {
		name: 'TW_RecreationDetail',
		mixins: [mixin],
		components: {
			Header,
			Footer,
			Pinglun,
		},
		data() {
			return {
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()+1 * 24 * 60 * 60 * 1000
					},
				},
				chooseDay: Date.now()+2 * 24 * 60 * 60 * 1000,
				showPrice:'',	//市场价
				discountPrice:'',	//销售价

				Id: '', //Id
				fullscreenLoading: true, //loading状态
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				recreationDetail: {}, //详情
				Gallerys:[],		//图片集
				pictureIndex: 0,	//大图索引,
				galleryIndex: 0,	//大图索引,
				showImage: false,	//大图显示状态
				CollectionState:'',	//收藏状态
				clickLock: false,	//操作锁定状态,
	
				commentsDialog: false,	//全部评论展示状态
				commentsList:[],		//全部评论数据
				gallerysDialog: false,	//图库展示状态
				
				recreationContent: '',	//玩乐详情富文本
				
				//图片
				focusPicture: '',		//首图
				otherPictureList: [],	//后四张图
				
				// Tab标题栏相关
				activeTab: "tab1",
				isAutoScrolling: false,
				scrollTimer: null,
				tabList: [{
						id: "tab1",
						label: "玩樂資訊",
					},
					{
						id: "tab2",
						label: "詳細介紹",
					},
					{
						id: "tab3",
						label: "訂購須知",
					},
					{
						id: "tab4",
						label: "費用明細",
					},
					{
						id: "tab5",
						label: "接送地點",
					},
				],
			}
		},
		computed: {
			limitedGallerys() {
				return this.recreationDetail.Gallerys.slice(0, 5); // 只取前5个元素
			}
		},
		mounted() {
			/*Tab标题栏使用*/
			this.$nextTick(() => {
				this.updateActiveTab();
				window.addEventListener("scroll", this.handleScroll, {
					passive: true
				});
				window.addEventListener("resize", this.handleScroll);
			});	
		},
		beforeDestroy() {
			/*Tab标题栏使用*/
			window.removeEventListener("scroll", this.handleScroll);
			window.removeEventListener("resize", this.handleScroll);
			if (this.scrollTimer) {
				clearTimeout(this.scrollTimer);
			}
		},
		created() {
			// 模拟获取url参数
			this.Id = this.$route.query.Id
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
				}
				this.getData()
			},
			//获取数据
			async getData() {
				const {
					data: res
				} = await getRecreationDetail(this.language, this.terminal, this.Id, this.token)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.recreationDetail = res.data
					document.title = this.recreationDetail.Title + ' | 景點玩樂 - 檀島旅遊 (繁體中文)'
					this.Gallerys = res.data.Gallerys
					// this.showPrice = this.recreationDetail.ShowPrice
					// this.discountPrice = this.recreationDetail.DiscountPrice
					this.showImage = true
					this.CollectionState = this.recreationDetail.CollectionState					
					
					//热词替换
					this.recreationContent = this.patchReplace(
					this.recreationDetail.RecreationHotKeywords,
					this.recreationDetail.Content,
					'/tw/recreation/detail?Id=')
					
					//新增图片解析
					this.pictureFilter(this.Gallerys)
					
					//取指定日期价格
					this.changeDate()
					
				} else {
					this.$message.error(res.errmsg);
				}
			},
			
			//切换图片
			changeGallery(i)
			{
				if(this.galleryIndex != i)
				{
					this.showImage = false
					this.galleryIndex = i
					setTimeout(() => {
						this.showImage = true
					}, 100)
				}
			},
			
			//收藏操作
			async collectionHandle(action)
			{
				if(this.clickLock)
				{
					return
				}
				this.clickLock = true	//锁住按钮
				if(this.loginStatus)
				{
					let params={
						Token:this.token,
						Terminal:this.terminal,
						ColumnId:1,
						Id:this.Id,
						Action:action
					}
					const { data: res } = await collection(params)
					if (res.errcode === 0) {						
						this.CollectionState = action
						this.$message({
						  message: '操作成功',
						  type: 'success'
						});
					} else {
						this.$message.error(res.errmsg);
					}
				}
				else
				{
					this.$router.push({
						path: '/tw/user/login?ReturnUrl=' + encodeURIComponent(window.location.href)
					})
				}
				this.clickLock = false	//解锁按钮
			},
			
			//图片解析处理
			pictureFilter(gallerys)
			{
				if(gallerys.length>0)
				{
					this.focusPicture = gallerys[0].Picture
					
					gallerys.forEach((item, index) => {
						if(index > 0 && index < 5)
						{
							this.otherPictureList.push(gallerys[index].Picture)
						}
					})
				}
			},
			
			//选定日期
			async changeDate()
			{
				this.fullscreenLoading = true
				const {
					data: res
				} = await getRecreationPrice(this.language, this.Id, this.formattedDate(this.chooseDay), 0)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					if(res.data.ValidDateList.length>0)
					{
						res.data.ValidDateList[0].PriceList.forEach((item, index) => {
							if(item.Max > 20)
							{
								this.showPrice = item.Price
								this.discountPrice = item.DiscountPrice
							}
						})
					}
					
					if(this.showPrice == '')
					{
						this.showPrice = this.ticketDetail.ShowPrice
						this.discountPrice = this.ticketDetail.DiscountPrice
					}
				} else {
					this.$message.error(res.errmsg);
				}
			},
			
			//立即预订
			booking()
			{
				// this.$router.push({
				// 	path: '/tw/recreation/booking?Id='+this.Id+'&BookingDate='+this.formattedDate(this.chooseDay)
				// })
				location.href = '/tw/recreation/booking?Id='+this.Id+'&BookingDate='+this.formattedDate(this.chooseDay)
			},
			
			//查看全部评论
			viewAllComments()
			{
				this.getAllComments()
			},
			
			//获取全部评论数据
			async getAllComments()
			{
				this.fullscreenLoading = true
				let params={
					PageIndex: 1,
					ColumnId: 1,
					DataId: this.Id,
				}				
				const {
					data: res
				} = await getAllComments(params.PageIndex, params.ColumnId, params.DataId)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.commentsList = res.data.DataList
					this.commentsDialog = true
				} else {
					this.$message.error(res.errmsg);
				}
			},
			
			//查看全部图片
			viewAllPictures()
			{
				this.galleryIndex = 0
				this.gallerysDialog = true
			},
			
			/*以下为Tab栏使用的方法*/
			handleTabClick(tab) {
				this.scrollToContent(tab.name);
			},
			handleScroll() {
				if (this.isAutoScrolling) {
					return;
				}
				this.updateActiveTab();
			},
			scrollToContent(id) {
				const target = document.getElementById(id);
				if (!target) {
					return;
				}
			
				this.activeTab = id;
				this.isAutoScrolling = true;
				window.scrollTo({
					top: target.offsetTop - TAB_OFFSET_TOP,
					behavior: "smooth",
				});
			
				if (this.scrollTimer) {
					clearTimeout(this.scrollTimer);
				}
				this.scrollTimer = setTimeout(() => {
					this.isAutoScrolling = false;
					this.updateActiveTab();
				}, 500);
			},
			updateActiveTab() {
				const threshold = TAB_OFFSET_TOP + 20;
				let currentId = this.tabList[0].id;
			
				this.tabList.forEach((item) => {
					const element = document.getElementById(item.id);
					if (element && element.getBoundingClientRect().top <= threshold) {
						currentId = item.id;
					}
				});
			
				if (
					window.innerHeight + window.pageYOffset >=
					document.documentElement.scrollHeight - 10
				) {
					currentId = this.tabList[this.tabList.length - 1].id;
				}
			
				this.activeTab = currentId;
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
	}
</style>